"use client";

import { captureClientException } from "@/lib/client-monitoring";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureClientException(error);
  }, [error]);

  // Auto-reload on chunk load errors (stale deployment)
  if (
    error.name === "ChunkLoadError" ||
    error.message?.includes("Failed to load")
  ) {
    if (typeof window !== "undefined") {
      window.location.reload();
      return null;
    }
  }

  return (
    <html>
      <body
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          fontFamily: "system-ui, sans-serif",
          background: "#0A0A0A",
          color: "#fff",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h2 style={{ marginBottom: "1rem" }}>Something went wrong</h2>
          <button
            onClick={() => reset()}
            style={{
              padding: "0.5rem 1rem",
              borderRadius: "0.375rem",
              background: "#D1F805",
              color: "#0A0A0A",
              border: "none",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
